export interface FormatDisplayNameParams {
  baseName: string;
  fleetTag?: string | null;
  titleName?: string | null;
}

const normalizeFleetTag = (fleetTag: string): string => {
  const trimmed: string = fleetTag.trim();

  const withoutBrackets: string = trimmed.startsWith('[') && trimmed.endsWith(']')
    ? trimmed.slice(1, -1)
    : trimmed;

  return withoutBrackets.trim().toUpperCase();
};

export const formatDisplayName = ({ baseName, fleetTag, titleName }: FormatDisplayNameParams): string => {
  const name: string = baseName.trim();
  const tag: string | null = fleetTag && fleetTag.trim().length > 0 ? normalizeFleetTag(fleetTag) : null;
  const title: string | null = titleName && titleName.trim().length > 0 ? titleName.trim() : null;

  if (tag && title) {
    return `[${tag}] ${title} - ${name}`;
  }
  if (tag) {
    return `[${tag}] ${name}`;
  }
  if (title) {
    return `${title} ${name}`;
  }
  return name;
};
